module.exports = __webpack_public_path__ + "img/img10.b30fcbc2.png";